<template>
  <section class="c-search-results-block">
    <h3 class="c-search-results-block__title">{{title}}</h3>
    <ol class="c-search-results-block__list">
      <li v-for="result in results" :key="result.id" @click="$emit('click',result)">
        <search-result :item="result" :type="type"/>
      </li>
      <li v-if="results.length < 1">There were no results of this type</li>
    </ol>
  </section>
</template>

<script>
const SearchResult = () => import("@/components/SearchResult");
export default {
  name: "SearchResultsBlock",
  components: {
    SearchResult
  },
  props: {
    title: {
      type: String,
      default: "Results"
    },
    results: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: "page"
    }
  }
};
</script>

<style lang="scss" scoped>
.c-search-results-block {
  margin-bottom: 25px;
  &__title {
    font-size: 16px;
    font-family: $font-frutiger-bold;
    color: $colour-nhs-black;
    margin: 10px 0 25px;
  }

  &__list {
    border-top: 1px solid $colour-nhs-pale-grey;
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      padding: 25px 0;
      @media screen and (min-width: 1024px) {
        padding: 25px;
      }
      transition: all ease-in-out 0.2s;
      border-bottom: 1px solid $colour-nhs-pale-grey;

      @media (hover: hover) {
        &:hover {
          cursor: pointer;
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.11);
          //   border-bottom: none;
        }
      }
    }
  }
}
</style>